export const sylndrDirections =
    'https://goo.gl/maps/Pw9dHb1RG27w7bFQ9?coh=178573&entry=tt';
export const MOBILE_SCREEN_LABEL = 'Mobile';
export const DESKTOP_SCREEN_LABEL = 'Desktop';
export const APP_STORE_LINK = 'https://apps.apple.com/eg/app/id6472655250';
export const GOOGLE_PLAY_LINK =
    'https://play.google.com/store/apps/details?id=com.Sylndr.app';
export const HUAWEI_PLAY_LINK = 'https://appgallery.huawei.com/app/C112534329';
export const SINGULAR_UNI_LINK_FINANCING =
    'https://sylndr.sng.link/Ewocx/odmq?_dl=sylndrapp%3A%2F%2FFinancingScreen&_smtype=3';
export const SINGULAR_UNI_LINK_CAR_PROFILE =
    'https://sylndr.sng.link/Ewocx/5piv?_ios_dl=sylndrapp%3A%2F%2FBuyCarScreen&_android_dl=sylndrapp%3A%2F%2Fbuy-used-cars%2Fegypt&_smtype=3';
export const SINGULAR_UNI_LINK_STICKY =
    'https://sylndr.sng.link/Ewocx/loax?_dl=sylndrapp%3A%2F%2Fbuy-used-cars%2Fegypt&_smtype=3 ';
export const SINGULAR_UNI_LINK_BANNERS =
    'https://sylndr.sng.link/Ewocx/le7y?_dl=sylndrapp%3A%2F%2Fbuy-used-cars%2Fegypt&_smtype=3 ';
export const SINGULAR_UNI_LINK_FINANCING_CAR_PROFILE =
    'https://sylndr.sng.link/Ewocx/uxj0?_dl=sylndrapp%3A%2F%2FFinancingScreen&_smtype=3';
